
export default function Header(){
    return(
        <div className="border-b shadow-md rounded   ">
            <h1 className="font-bold text-center text-3xl mb-2 mt-3">CODEHELP BLOGS</h1>
           
        </div>
    )
    
}